import { Box, Typography } from '@mui/material';
import React from 'react';
import { T } from '../../theme/tokens';

export type ColorVariant = 'final' | 'socio' | 'assessment' | 'interview' | 'commander';

const VARIANT_STYLES: Record<ColorVariant, { bg: string; color: string; border: string }> = {
  final:      { bg: T.surfaceAlt,              color: T.ink,       border: T.border },
  socio:      { bg: 'rgba(107,91,58,0.08)',    color: T.tierTop,   border: 'rgba(107,91,58,0.2)' },
  assessment: { bg: 'rgba(154,142,114,0.12)',  color: T.tierMid,   border: 'rgba(154,142,114,0.25)' },
  interview:  { bg: T.surfaceAlt,              color: T.textMuted, border: T.borderInput },
  commander:  { bg: T.surfaceAlt,              color: T.textMuted, border: T.borderInput },
};

export interface ScoreBoxProps {
  label: string;
  value: number | null | undefined;
  variant?: ColorVariant;
  suffix?: string;
  badge?: React.ReactNode;
}

const ScoreBox: React.FC<ScoreBoxProps> = ({ label, value, variant = 'final', suffix, badge }) => {
  const styles = VARIANT_STYLES[variant];
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: '12px',
        py: '8px',
        minWidth: 72,
        bgcolor: styles.bg,
        border: `1px solid ${styles.border}`,
        borderRadius: '2px',
        gap: '2px',
      }}
    >
      <Typography sx={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.1em', color: T.textSubtle, whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
      {badge}
      <Typography sx={{ fontSize: 20, fontWeight: 500, color: value != null ? styles.color : T.textFaint, fontVariantNumeric: 'tabular-nums', lineHeight: 1.1 }}>
        {value != null ? `${Number(value).toFixed(1)}${suffix ?? ''}` : '—'}
      </Typography>
    </Box>
  );
};

export default ScoreBox;
